import React from 'react'
import './About.css'

const About = () => {
  return (
    <div className='About'>
      <h1>A PROPOS</h1>
      <h2>VALENTIN BRUHIÈRE</h2>
      <div className="subtitle-about">
        <p>Diplômée de l'ESRA  (section Montage/Post-Production) en 2017 et parlant anglais couramment, j'ai commencé ma carrière en tant qu'assistant monteur dans des post-productions pub et VFX (Mathematic, Wanda), pour ensuite me consacrer pleinement au montage à partir de 2019.</p>
        <p>Je dispose de deux stations de montage (une fixe et une portable) ainsi que des licences Adobe et Davinci Resolve.</p>
      </div>
    </div>
  )
}

export default About